import { observer } from 'mobx-react';
import * as React from 'react';
import Modal from '../../../../Modal';
import GroupParticipantsStore from '../../../Group/GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../../Group/GroupParticipantsStore/Types';
import AddParticipantStore from '../../Store';
import Body from './Body';
import CheckmarkIcon from './CheckmarkIcon';

export interface Props {
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
  participantsAdded: number;
}

export const resetModal = (
  store: AddParticipantStore,
  groupParticipantsResource: GroupParticipantsResource,
  groupParticipantsStore: GroupParticipantsStore,
) => {
  groupParticipantsStore.modalStore.close();
  store.ready(groupParticipantsResource);
  groupParticipantsStore.loading();
};

const ModalState: React.FC<Props> = ({
  store,
  groupParticipantsResource,
  groupParticipantsStore,
  participantsAdded,
}) => {
  switch (groupParticipantsStore.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          title={<CheckmarkIcon className="mx-auto mt-16" />}
          close={() => resetModal(store, groupParticipantsResource, groupParticipantsStore)}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          additionalClasses="text-center"
        >
          <Body
            store={store}
            groupParticipantsResource={groupParticipantsResource}
            groupParticipantsStore={groupParticipantsStore}
            participantsAdded={participantsAdded}
          />
        </Modal>
      );
  }
};

export default observer(ModalState);
